import { render, staticRenderFns } from "./collect.vue?vue&type=template&id=b634545c&"
import script from "./collect.js?vue&type=script&lang=js&"
export * from "./collect.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports